import { Box, Stack, styled, Tab, Tabs } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const ContentTabWrapper = styled(Stack)(() => ({
  height: "100%",
  flex: 1,
  minHeight: pxToRem(600),
}));

export const CalendarWrapper = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.functions.pxToRem(24),
}));

export const DeclareLeaveWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(20),
  borderRadius: pxToRem(12),
  //   padding: `${pxToRem(20)} ${pxToRem(40)}`,
  //   margin: pxToRem(32),
  height: `auto`,
  flex: 1,
  [theme.breakpoints.up("xxl")]: {
    maxWidth: `calc(100vw - ${pxToRem(700)})`,
  },
  backgroundColor: theme.palette.background.bgPrimary,
  ".MuiDateCalendar-root.calendar-time-keeping": {
    overflow: "visible",
    maxHeight: `calc(100vh - ${pxToRem(230)})`,
    height: `calc(100vh - ${pxToRem(230)})`,
    gap: 0,
    ".MuiPickersDay-today": {
      border: "none !important",
      boxShadow: `0 0 0 1.5px ${theme.palette.stroke.strokeBrand} !important`,
      zIndex: 1,
      margin: pxToRem(1),
      ".day": {
        color: theme.palette.text.textLink,
      },
    },
  },
  ".MuiMonthCalendar-root.calendar-time-keeping ": {
    width: pxToRem(320),
  },
  ".MuiDateCalendar-viewTransitionContainer": {
    border: "none !important",
    maxHeight: `unset !important`,
    height: "100%",
    paddingRight: pxToRem(24),
    paddingLeft: pxToRem(24),
  },

  ".MuiDayCalendar-header": {
    display: "flex",
    span: {
      flex: 1,
      textAlign: "center",
    },
  },
}));

export const TabWrapper = styled(Tab)(({ theme }) => ({
  color: theme.palette.colorsBase.gray_6,
  svg: {
    path: {
      width: pxToRem(12),
      fill: theme.palette.colorsBase.gray_6,
    },
  },
  "&.Mui-selected": {
    color: theme.palette.text.textLink,
    svg: {
      path: {
        fill: theme.palette.text.textLink,
      },
      rect: {
        fill: theme.palette.text.textLink,
      },
    },
  },
}));

export const TabsCustom = styled(Tabs)(({ theme }) => ({
  width: "100%",
  ".MuiTabs-scrollButtons": {
    width: pxToRem(32),
  },
}));

export const TabCustom = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: pxToRem(8),
  padding: `0 ${pxToRem(5)}`,
  fontSize: `${theme.typography.h6}`,
  lineHeight: theme.typography.lineHeight.sm,
  fontWeight: theme.typography.fw_semibold_500,
}));
